<template>
  <SogForm
    ref="_form"
  >
    <SogFormField>
      <SogTextBox
        v-model="_emails"
        placeholder="E-Mail-Adressen (mit ; getrennt)"
        name="registrationOfficeEmails"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_prefixes"
        placeholder="Kennzeichen-Präfixe (mit ; getrennt, z. B. OS;OSL)"
        name="registrationOfficePrefixes"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_districtKeys"
        placeholder="Kreisschlüssel (mit ; getrennt; bei mehreren Behörden mit gleichem Schlüssel mit Zusatzziffer, z. B. 03159/1)"
        name="registrationOfficeDistrictKeys"
      />
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {ref, watch} from "vue";

const _form = ref<InstanceType<typeof SogForm> | null>(null)

interface Props {
  details?: PersonDetails
}

const props = withDefaults(defineProps<Props>(), {
  details: undefined
})

const _emails = ref<string>("")
const _prefixes = ref<string>("")
const _districtKeys = ref<string>("")

function validate(): boolean {
  return _form.value?.validate() ?? false;
}

watch(props, () => {
  _emails.value = props.details?.getValue(PersonDetailsId.RegistrationOfficeEmails) ?? ""
  _prefixes.value = props.details?.getValue(PersonDetailsId.RegistrationOfficePrefixes) ?? ""
  _districtKeys.value = props.details?.getValue(PersonDetailsId.RegistrationOfficeDistrictKeys) ?? ""
}, {immediate: true})

function getDetails(): PersonDetails | undefined {
  if (!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setValue(PersonDetailsId.RegistrationOfficeEmails, _emails.value.trim())
  details.setValue(PersonDetailsId.RegistrationOfficePrefixes, _prefixes.value.trim().toUpperCase())
  details.setValue(PersonDetailsId.RegistrationOfficeDistrictKeys, _districtKeys.value.trim())
  return details;
}

defineExpose({
  validate,
  getDetails
})
</script>
